import type { ReactNode } from 'react'
import { createPortal } from 'react-dom'

interface PortalProps {
	children: ReactNode
	container?: HTMLElement
}

/**
 * Portal component with proper SSR handling
 * Renders children into a DOM node outside the component tree
 * Handles server-side rendering by checking for document availability
 */
export function Portal({ children, container }: PortalProps) {
	// Handle SSR - return children directly if document is not available
	if (typeof document === 'undefined') {
		return <>{children}</>
	}

	// Use provided container or default to document.body
	const targetContainer = container || document.body

	return createPortal(children, targetContainer)
}
